import { Article, WithContext } from 'schema-dts';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';

import { Article as CmsArticle } from '../../../../types/__codegen__/sanity/graphql';
import buildCorporationSchema from '../build-corporation-schema';

const buildArticleSchema = (article: CmsArticle): WithContext<Article> => {
  const { _createdAt, name, descriptionRaw, bodyRaw, imageObject } = article;
  const descriptionPlainText = portableTextToPlain(descriptionRaw);
  const articleBodyPlainText = portableTextToPlain(bodyRaw);
  const articleTags = article.tags?.map((tag) => tag?.name).filter(Boolean) as string[];

  const ahmCorporation = buildCorporationSchema();

  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    articleBody: articleBodyPlainText,
    author: ahmCorporation,
    datePublished: _createdAt,
    description: descriptionPlainText,
    headline: name as string,
    image: imageObject?.image?.asset?.url as string,
    keywords: articleTags,
    publisher: ahmCorporation,
    thumbnailUrl: imageObject?.image?.asset?.url as string,
  };
};

export default buildArticleSchema;
